import { useEffect } from "react";
import { setupIntercom } from "../../helpers/helpers";
import { useGetUserDetails } from "../../hooks/useGetUserDetails";

/** Intercom and other shell-wide side effects for the authenticated layout. */
export const ShellEffects = () => {
  const {
    userDetails: { id, email }
  } = useGetUserDetails();

  useEffect(() => {
    setupIntercom(email, id);
  }, [email, id]);

  return null;
};
